var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.75 2a9.75 9.75 0 110 19.5 9.75 9.75 0 010-19.5zm0 1.5a8.25 8.25 0 100 16.5 8.25 8.25 0 000-16.5zm.16 6.75c.38 0 .7.29.75.65v3.6h.4a.75.75 0 01.1 1.5h-2.4a.75.75 0 01-.1-1.49h.5v-2.76h-.4a.75.75 0 01-.74-.64V11c0-.39.27-.7.64-.75h1.25zM11.61 7a1 1 0 011 .97V8a1 1 0 11-1-1z"
  })));
}
export default SvgInfo;